import React from "react";
import { useTranslation } from "react-i18next";

import PDPConfiguratorOptionsWrapper from "./PDPConfiguratorOptions";
import PDPConfigurator from "../pdp/PDPConfigurator";
import PDPProductViewer from "../pdp/PDPProductViewer";
import PDPProductSpecification from "../pdp/PDPProductSpecification";
import PDPProductThumbs from "../pdp/PDPProductThumbs";
import useGlobalStore from "@store/global";

import { useActiveProductData } from "@store/pdp";

import { CONFIGURATOR_SKU } from "@constants";

import "./pdp.scss";
import PDPVerticalProductSpecification from "./PDPVerticalProductSpecification";

const PDP = ({
  allowOrder,
  careAndMaintenance,
  deliveryTexts,
  PDPNotOnEcomMarket,
  deliveryCostsNoticeDisabled,
  deliveryCostsNoticeLinkUrl,
  deliveryCostsNoticeLinkDescription,
  deliveryCostsNoticeThreshold,
  klarnaMarkets,
  klarnaMarketThreshold,
  klarnaScripts
}) => {
  const [activeProductData] = useActiveProductData();
  const currentMarket = useGlobalStore((state) => state.currentMarket);
  const { t } = useTranslation();
  const texts = {
    productError: t(
      "FritzHansen_Project_ConsumersAndProfessionals_PDP_ProductError"
    ),
  };

  return (
    <>
      {activeProductData && (
        <>
          {activeProductData === CONFIGURATOR_SKU.NONE ? (
            <div className="error">
              <h2>{texts.productError}</h2>
            </div>
          ) : (
            <>
              <PDPProductViewer />
              <PDPConfigurator
                allowOrder={allowOrder}
                currency={currentMarket?.currency?.value}
                PDPNotOnEcomMarket={PDPNotOnEcomMarket}
                deliveryCostsNoticeDisabled={deliveryCostsNoticeDisabled}
                deliveryCostsNoticeLinkUrl={deliveryCostsNoticeLinkUrl}
                deliveryCostsNoticeLinkDescription={deliveryCostsNoticeLinkDescription}
                deliveryCostsNoticeThreshold={deliveryCostsNoticeThreshold}
                klarnaMarkets={klarnaMarkets}
                klarnaMarketThreshold={klarnaMarketThreshold}
                klarnaScripts={klarnaScripts}
              >
                <PDPConfiguratorOptionsWrapper />
              </PDPConfigurator>

              {/* <PDPDeliveryInfo modifier="d-n-vp5" /> */}

              {/* <PDPProductThumbs /> */}

              <PDPProductSpecification
                deliveryTexts={deliveryTexts}
                careAndMaintenance={careAndMaintenance}
                defaultDimensionUnit={currentMarket?.defaultDimensionUnit?.value}
              />
              <PDPVerticalProductSpecification
                deliveryTexts={deliveryTexts}
                careAndMaintenance={careAndMaintenance}
                defaultDimensionUnit={currentMarket?.defaultDimensionUnit?.value}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default PDP;
